import React from 'react';

import { Fade } from '@core/transitions/Fade';
import type { FadeProps } from '@core/transitions/Fade';
import { Slide } from '@core/transitions/Slide';
import type { SlideDirection } from '@core/transitions/Slide';

type TransitionProps = Pick<FadeProps, 'children' | 'timeout' | 'in'>;

export type Props = TransitionProps & {
  variant: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right';
};

const slideDirectionMap: Partial<Record<Props['variant'], SlideDirection>> = {
  'slide-up': 'up',
  'slide-left': 'left',
  'slide-right': 'right',
};

const ModalTransition = React.forwardRef(function Transition(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { children, variant, ...rest } = props;
  const transitionProps = { ref, appear: true, ...rest };

  const direction = slideDirectionMap[variant];

  if (direction) {
    return (
      <Slide direction={direction} {...transitionProps}>
        {children as React.ReactElement}
      </Slide>
    );
  }

  return <Fade {...transitionProps}>{children}</Fade>;
});

export default ModalTransition;
